import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AccountService } from 'src/app/shared/account.service';
import { map } from 'rxjs/operators';
import { CanactivateviaadminService } from './canactivateviaadmin.service';
import { CanactivateviasuperadminService } from './canactivateviasuperadmin.service';
@Injectable({
  providedIn: 'root'
})
export class CanactivateadminsuperadminService implements CanActivate{

  constructor(private canactivateviaadmin:CanactivateviaadminService,private canactivateviasuperadmin:CanactivateviasuperadminService) { }
  canActivate(route:ActivatedRouteSnapshot, state:RouterStateSnapshot):Observable<boolean>|boolean {
  if(this.canactivateviaadmin){return true}
  if(this.canactivateviasuperadmin){return true}
  else return false
  }

}
